const PLUGIN_NAME = 'ebooks';

export { PLUGIN_NAME };
